import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler } from '@angular/common/http';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CacheMapService } from '../../services/caching/cache-map.service';

const CACHABLE_URL = {
    dropdown: "autofill",
    dealer: "asset/details",
    fetchQuotationStatus:"quotation/status"
}

@Injectable()

export class CachingInterceptor implements HttpInterceptor {
    constructor(private cache: CacheMapService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRequestCachable(req)) {
            return next.handle(req);
        }
        const cachedResponse = this.cache.get(req);
        if (cachedResponse !== null) {
            return of(cachedResponse);
        }
        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    this.cache.put(req, event);
                }
            })
        );
    }

    private isRequestCachable = (req: HttpRequest<any>) => {
        if (req.method == "GET") {
            for (var api in CACHABLE_URL) {
                if (req.url.includes((CACHABLE_URL[api]))) {
                    return true;
                }
            }
        }
        else { return false }
    }
}

